export default __webpack_public_path__ + "358b4955ca82f568ce758a9392e20c5a.png";